var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AddBox, IndeterminateCheckBox } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { HoverIconButton, IconWrapper, NoSpinInput, Wrapper, } from './CustomNumberField.Styles';
export var CustomNumberField = function (props) {
    var _a = useState(0), value = _a[0], setValue = _a[1];
    var textFieldRef = useRef();
    var handleOnChange = function (value) {
        props.onValueChange && props.onValueChange(value);
        setValue(value);
    };
    useEffect(function () {
        setValue(props.value == null || props.value === NaN ? 0 : props.value);
    }, [props.value]);
    return (React.createElement(Wrapper, { fullWidth: props.fullWidth },
        React.createElement(NoSpinInput
        // placeholder={props.label}
        , __assign({ 
            // placeholder={props.label}
            inputRef: textFieldRef }, props, { type: 'number', variant: 'outlined', margin: 'dense', InputLabelProps: __assign({ shrink: true }, props.InputLabelProps), error: props.error, onBlur: props.onBlur, InputProps: __assign({ notched: false }, props.InputProps), value: value, onChange: function (e) {
                if (props.isFloat)
                    handleOnChange(parseFloat(e.target.value));
                else
                    handleOnChange(parseInt(e.target.value));
            } })),
        React.createElement(IconWrapper, null,
            React.createElement(HoverIconButton, { size: 'small', disableFocusRipple: true, onClick: function () {
                    if (props.min === undefined || value > props.min) {
                        handleOnChange(value - 1);
                    }
                } },
                React.createElement(IndeterminateCheckBox, { fontSize: 'medium' })),
            React.createElement(HoverIconButton, { size: 'small', disableFocusRipple: true, onClick: function () {
                    if (props.max === undefined || value < props.max) {
                        handleOnChange(value + 1);
                    }
                } },
                React.createElement(AddBox, { fontSize: 'medium' })))));
};
//# sourceMappingURL=CustomNumberField.js.map